import { DefaultState, DropdownItem } from 'store/types';

export const READ_RESERVATIONS_FILTERS_REQUEST = 'READ_RESERVATIONS_FILTERS_REQUEST';
export const READ_RESERVATIONS_FILTERS_SUCCESS = 'READ_RESERVATIONS_FILTERS_SUCCESS';
export const READ_RESERVATIONS_FILTERS_FAILURE = 'READ_RESERVATIONS_FILTERS_FAILURE';

export interface ReservationsFilterData {
  isBooked: DropdownItem[];
  dates: DropdownItem[];
  statuses: DropdownItem[];
}

export type ReservationsFiltersState = DefaultState & {
  contents?: ReservationsFilterData;
};

interface ReadReservationsFiltersRequest {
  type: typeof READ_RESERVATIONS_FILTERS_REQUEST;
}

interface ReadReservationsFiltersSuccess {
  type: typeof READ_RESERVATIONS_FILTERS_SUCCESS;
  contents: ReservationsFilterData;
}

interface ReadReservationsFiltersFailure {
  type: typeof READ_RESERVATIONS_FILTERS_FAILURE;
}

export type ReservationsFiltersActionTypes =
  | ReadReservationsFiltersRequest
  | ReadReservationsFiltersSuccess
  | ReadReservationsFiltersFailure;
